export function getMargin(transformer) {
    return Object.freeze({
        l: transformer.margin('48px'),
        m: transformer.margin('32px'),
        s: transformer.margin('24px'),
        xs: transformer.margin('16px'),
    });
}
